export const calendarCellHeight = 32
export const calendarHeaderHeight = 49
export const groupHeaderWidth = 220

export const EMPLOYEE_DATASOURCE_ID = 'Employee'
export const WORKUNIT_DATASOURCE_ID = 'WorkUnit'
export const CALENDAR_DATASOURCE_ID = 'Event'
export const CALENDAR_DOWNLOAD_URL = 'v2/Tapahtuma/TyontekijanakymaExcel'
